import React, { Component } from "react";

import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import Uri from "jsuri";

import {
  MetricTable,
  sortNumeric,
  selectFormat,
  TableContentCell,
  Error,
} from "./../../Utils/Utils.js";

import numeral from "./../../../../node_modules/numeraljs/numeral.js";

import { PieChart, Pie, Cell } from "recharts";

const COLORS = ["#FC6D52", "#f4f4f4"];

const metric = (cell, row, rowIndex, params) => {
  const props = { ...cell, ...params };
  return <MetricTable {...props} />;
};

const graphMetric = (cell, row, rowIndex, params) => {
  const value = cell && (cell.value || 0);
  const data = [{ value: 100 * value }, { value: 100 * (1 - value) }];
  return (
    <PieChart height={45} width={45}>
      <Pie
        dataKey="value"
        data={data}
        outerRadius="100%"
        innerRadius="75%"
        startAngle={450}
        endAngle={90}
      >
        {data.map((entry, index) => (
          <Cell key={`cell-${entry}`} fill={COLORS[index]} />
        ))}
      </Pie>
      <text
        x="50%"
        y="50%"
        textAnchor="middle"
        dominantBaseline="middle"
        className="piechart-metric__xsmall"
      >
        {numeral(data[0].value).divide(100).format("%")}
      </text>
    </PieChart>
  );
};

class TwitterTop5Posts extends Component {
  componentDidMount() {
    this.props.childRef(this);
  }

  renderTable(data) {
    const { cells, title, url } = this.props;

    // add unique ids
    data.forEach((d, i) => (d.id = i));

    const isVideoWidget = title.includes("Videos");
    const columnLabel = isVideoWidget ? "Views" : "Impressions";
    const defaultSortType = isVideoWidget ? "views" : "engagements";

    const columns = [
      {
        dataField: "title",
        text: "Title",
        style: { width: "320px", minWidth: "320px", textAlign: "left" },
        headerAlign: "left",
        formatter: TableContentCell,
        formatExtraData: {
          name: new Uri(url).hasQueryParam("p")
            ? new Uri(url).getQueryParamValue("p")
            : url.split("/")[2],
        },
        csvFormatter: (cell, row) => row && (row.title || row.tweet_text || ""),
        sort: true,
      },
      {
        dataField: "views",
        text: columnLabel,
        style: { width: "140px", minWidth: "140px" },
        formatter: metric,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "engagements",
        text: "Engagements",
        style: { width: "140px", minWidth: "140px" },
        formatter: metric,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "paid",
        text: "Paid Impression %",
        style: { width: "140px", minWidth: "140px" },
        formatter: graphMetric,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
    ];

    const defaultSorted = [
      {
        dataField: defaultSortType,
        order: "desc",
      },
    ];

    let selected_columns = columns;
    if (cells && cells.length) {
      selected_columns = [];
      cells.forEach((cell, i) => {
        selected_columns.push(columns.find((o) => o.dataField === cell));
      });
    }

    const filename = title.split(" ").join("_") || "spreadsheet";
    return (
      <ToolkitProvider
        keyField="id"
        data={data}
        columns={selected_columns}
        striped={false}
        hover={false}
        bordered={false}
        exportCSV={{
          fileName: filename + ".csv",
          exportAll: false,
          onlyExportFiltered: true,
        }}
      >
        {(props) => (
          <BootstrapTable
            {...props.baseProps}
            {...props.csvProps}
            defaultSorted={defaultSorted}
            ref={(el) => (this.childRef = el)}
          />
        )}
      </ToolkitProvider>
    );
  }

  builtInExportCSV = () => this.childRef;

  render() {
    const { data } = this.props;

    if (data.hasData === false) {
      return <Error minHeight={360} />;
    }

    return this.renderTable(data.data);
  }
}

export default TwitterTop5Posts;
